module.exports = __webpack_public_path__ + "static/media/refresh-icon-hover.9b8571af.svg";